import { ICommonObject } from 'src/app/shared/models/common.model'

export enum SortDirect {
  Asc = 'asc',
  Desc = 'desc',
}

export interface IGetColumnSettingPayload {
  userId: string
  tableName: string
}

export interface IDateFilterProps {
  dateType: string
  dateFrom: string | null
  dateTo: string | null
}

export interface IPostColumnSettingPayload extends IGetColumnSettingPayload {
  items: Array<Pick<IColumnSetting, 'isSelect' | 'propertyName'>>
}

export interface IColumnSetting {
  defaultSelect: boolean
  defaultSort: boolean
  displayOrder: number
  isSelect: boolean
  propertyName: string
  sortDirection: SortDirect | null
}

export interface IGetDataPayload {
  searchTerm: string
  searchColumns: Array<string>
  isDesc: boolean // will be removed later
  sortColumns: Array<string> // will be removed later
  sortColumnsDictionary: ICommonObject
  pageSize: number
  pageIndex: number
  filterOption?: number
  dateFilter?: IDateFilterProps[]
  params?: { isActive: boolean }
}

export interface IGetExportData extends IGetDataPayload {
  export: {
    chosenColumnNameList: ICommonObject
    pageName: string
    header: string
  }
}
